module.exports = __webpack_public_path__ + "static/media/1650-onsecond.d9ca5598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/1650-onsecond.jpg
// module id = 375
// module chunks = 0